import * as React from "react"
import { 
  ImageInput, 
  ImageField, 
} from "react-admin"
import { Grid } from "@mui/material"

const ImagesTab = () => {
  return (
    <Grid container width={{ xs: "100%", xl: 800 }} spacing={2}>
      <Grid item xs={12}>
        <ImageInput 
          source="coverImage" 
          label="封面圖片" 
          accept={{ 'image/*': ['.png', '.jpg'] }} 
          sx={{
            "& .previews": {
              backgroundColor: "#f0f0f0", // 外層容器灰底
              padding: "10px", // 圖片周圍留白
              borderRadius: "4px", // 圓角效果
              border: "1px solid #ccc", // 灰色邊框
            },
          }}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item xs={12}>
        <ImageInput 
          source="templateImage" 
          label="封面模板圖片" 
          accept={{ 'image/png': ['.png'] }} 
          sx={{
            "& .previews": {
              backgroundColor: "#f0f0f0",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            },
            marginTop: "1rem",
          }}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
      <Grid item xs={12}>
        <ImageInput 
          source="otherImage" 
          label="其他圖片" 
          accept={{ 'image/*': ['.png', '.jpg'] }} 
          multiple 
          sx={{
            "& .previews": {
              backgroundColor: "#f0f0f0",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ccc",
            },
            marginTop: "1rem",
          }}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </Grid>
    </Grid>
  )
}

export default ImagesTab;
